import {
  RESET_SERVICE_CHANGE,
  SET_SC_SELECTED_SERVICE,
  SET_SC_SELECTED_WASTE_STREAM,
  SET_SC_SELECTED_CUSTOMER_ID,
  CLEAR_SC_SUBMIT_DETAILS,
  SET_SUBMIT_ADD_FLOW_ANALYTICS,
  SET_SUBMIT_EDIT_FLOW_ANALYTICS,
  CLEAR_SC_ON_SERVICE_CHANGE_TYPE,
  SET_SHOW_ALL_SERVICE_OPTIONS,
  SET_REQUEST_BUTTON_CLICKED,
} from "constants-lib/actionTypes"

export const setScSelectedService = (data) => ({
  type: SET_SC_SELECTED_SERVICE,
  payload: data,
})

export const setScSelectedWasteStream = (data) => ({
  type: SET_SC_SELECTED_WASTE_STREAM,
  payload: data,
})

export const resetServiceChange = () => ({
  type: RESET_SERVICE_CHANGE,
})

export const setScSelectedCustomerId = (data) => ({
  type: SET_SC_SELECTED_CUSTOMER_ID,
  payload: data,
})

export const clearScSubmitDetails = () => ({
  type: CLEAR_SC_SUBMIT_DETAILS,
})

export const setScAddAnalyticsDetails = (data) => ({
  type: SET_SUBMIT_ADD_FLOW_ANALYTICS,
  payload: data,
})

export const setScEditAnalyticsDetails = (data) => ({
  type: SET_SUBMIT_EDIT_FLOW_ANALYTICS,
  payload: data,
})

export const clearOnServiceChangeType = () => ({
  type: CLEAR_SC_ON_SERVICE_CHANGE_TYPE,
})

export const setShowAllServiceOptions = (isSeeAllOptionsClicked) => ({
  type: SET_SHOW_ALL_SERVICE_OPTIONS,
  payload: isSeeAllOptionsClicked,
})

export const setRequestButtonClicked = (isRequestButtonClicked) => ({
  type: SET_REQUEST_BUTTON_CLICKED,
  payload: isRequestButtonClicked,
})
